<template>
  <div class="p-4 bg-white rounded-lg h-100" v-if="isDataLoaded">
    <DataTable
      :table_state="table_state"
      :store_names="store_names"
      :addComponent="componentForAdding"
      :editComponent="componentForEditing"
      :detailsComponent="componentForDetails"
      :delete_url="delete_url"
      :isFilterRequiredForExport="true"
      :urls="urls"
    />
  </div>
</template>

<script>
import DataTable from "@/own/components/DataTable.vue";
// import AddItem from "@/own/components/fulfillment/bundles/ActionsDialog.vue";
// import EditItem from "@/own/components/fulfillment/bundles/EditItem";
import AddAdjustment from "@/own/components/warehouseManagement/inventoryBalance/AddAdjustment";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import {
  EXPORT_TABLE_DATA,
  SET_TABLE_FILTER,
  SET_TABLE_PAGE,
  SET_TABLE_PERPAGE,
  SET_TABLE_SORTBY,
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_STRUCTURE,
} from "@/core/services/store/inventoryBalance.module";
export default {
  name: "InventoryBalance",
  components: { DataTable },
  data: () => ({
    componentForEditing: null,
    componentForAdding: null,
    componentForDetails: AddAdjustment,
    delete_url: `${process.env.VUE_APP_BASE_URL}/fulfillment/bundles/destroy`,
    table_state: {
      UPDATE_TABLE_STRUCTURE: UPDATE_TABLE_STRUCTURE,
      UPDATE_TABLE_DATA: UPDATE_TABLE_DATA,
      SET_TABLE_SORTBY: SET_TABLE_SORTBY,
      SET_TABLE_FILTER: SET_TABLE_FILTER,
      SET_TABLE_PERPAGE: SET_TABLE_PERPAGE,
      SET_TABLE_PAGE: SET_TABLE_PAGE,
      EXPORT_TABLE_DATA: EXPORT_TABLE_DATA,
    },
    store_names: {
      getTableFilters: "getINVENTBALANCETableFilters",
      getTableState: "getINVENTBALANCETableState",
      getTableData: "getINVENTBALANCETableData",
      getTableHeaders: "getINVENTBALANCETableHeaders",
      getTableProperties: "getINVENTBALANCETableProperties",
      getTableExportUrl: "getINVENTBALANCEExportUrl",
      getTablePermissions: "getINVENTBALANCETablePermissions",
      getUploadType: "getINVENTBALANCEUploadType",
    },
    urls: {
      adjustment: `/warehouse_management/inventory_adjustments/create`,
    },
  }),
  methods: {
    async initTableContent() {
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_STRUCTURE, {});
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_DATA, {});
    },
  },
  computed: {
    isDataLoaded: function () {
      return this.$store.getters[this.store_names.getTableData];
    },
  },
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.initTableContent();
  },
};
</script>
